import Panel from '../components/panel'
import {Button} from '../components/button'
import PropertyInput from "../components/inputs/input-property.tsx";

import { useStore } from "../state/state.ts";
import { MODAL_CONFIRM_BUTTON_LABEL } from "../config.ts";

export default function ModalPhotovoltaik() {
    const pop_modal = useStore((state)=>state.pop_modal);
    const close_menu = useStore((state) => state.close_menu);
    const api_recalculate = useStore((state) => state.api_recalculate);
    const init_property_if_undefined = useStore((state) => state.init_property_if_undefined);
  return (<Panel >
            <h1>Wird Photovoltaik genutzt?</h1>
            <PropertyInput type="photovoltaik"/>
            <PropertyInput type="photovoltaik_datum"/>
            <PropertyInput type="photovoltaik_annual_yield_kWh"/>
            <PropertyInput type="photovoltaik_battery_storage"/>

            <Button label={MODAL_CONFIRM_BUTTON_LABEL} onClick={()=>{
                close_menu();
                init_property_if_undefined("photovoltaik");
                api_recalculate();
                pop_modal();
            }}/>
         </Panel>)
}